// App.tsx or App.jsx
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import Home from "./pages/Home";
import JSONTool from "./pages/JSONTool";
import Base64Tool from "./pages/Base64Tool";
import JSONToCSVTool from "./pages/JSONToCSVTool";
import NavBar from "./components/NavBar";

import "./App.css";

function App() {
  return (
    <Router>
      <NavBar />
      <div className="container app-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/jsonlint" element={<JSONTool />} />
          <Route path="/base64decode" element={<Base64Tool />} />
          <Route path="/jsontocsv" element={<JSONToCSVTool />} />
        </Routes>
      </div>
      <footer className="text-center py-3 app-footer">
        <small>
          &copy; {new Date().getFullYear()} dLabs. All rights reserved.
        </small>
      </footer>
    </Router>
  );
}

export default App;
